import Automatons from './Automatons.redux';

export default Automatons;
